const toggleElementByClassName = (classname: string, hide: boolean): void => {
  const el: any = document.getElementsByClassName(classname)[0] || null;
  if (el) {
    el.style.display = hide ? 'none' : 'block';
  }
};

export default toggleElementByClassName;
